import styled from 'styled-components';

interface TextContainerProps {
	$padding?: string;
	$textAlign?: string;
}

export const TextContainer = styled.div<TextContainerProps>`
	padding: ${props => props.$padding || '8px 12px'};
	width: 91.4%;
	text-align: ${props => props.$textAlign || 'initial'};
	max-height: 80px;
	overflow: auto;
`;
